import apiClient from "@/lib/api/api-client";
import type { AccessRole } from "@/lib/api/portal-access-role";
import { env } from "@/config/env";

export interface RegisterUserRequest {
  company_name: string;
  contact_name: string;
  email: string;
  password: string;
  terms_accepted: boolean;
  /** Slice 6 only; omitted on legacy signup when the flag is off. */
  access_role?: AccessRole;
}

export async function registerUser(payload: RegisterUserRequest) {
  const { data } = await apiClient.post<unknown>(env.userRegisterPath, payload);
  return data;
}
